import type { FC } from 'react';

import { useHeaderMeasure } from '@makemydeal/dr-dash-components';
import { DealAssistantPanel, useDealAssistant } from '@makemydeal/dr-dash-deal-assistant';

import { LayoutPanel } from './DealAssistantHost.style';

export const DealAssistantDockedPanel: FC<{ offset: number }> = ({ offset }) => {
    const { isOpen } = useDealAssistant();
    const { height } = useHeaderMeasure();

    return isOpen ? (
        <LayoutPanel $top={height} $offset={offset} data-testid="deal-assistant-docked">
            <DealAssistantPanel />
        </LayoutPanel>
    ) : null;
};
